import React from 'react';
import { Col, Row, Text, Input, SelectPicker } from 'rsuite';

const PermitFilters = ({
    searchFilter,
    setSearchFilter,
    sortFilter,
    setSortFilter,
    sortOptions,
    statusFilter,
    setStatusFilter,
    statusOptions,
    registrationVerbiage,
    registrationTypeVerbiage,
    ownerLabel
}) => (
    <Row className='mb-20'>
        <Col xs={24} md={12} className='sm-pb-10'>
            <Text className='mb-4 text-small'>Search for a {registrationVerbiage}</Text>
            <Input
            className='ellipsis-placeholder'
                placeholder={`Search by address, ${registrationTypeVerbiage.toLowerCase()} number, ${ownerLabel} name...`}
                value={searchFilter}
                onChange={(value) => setSearchFilter(value)}
            />
        </Col>
        <Col xs={24} md={12} lg={5} lgPush={2}  className='sm-pb-10'>
            <Text className='mb-4 text-small'>Status</Text>
            <SelectPicker
                labelKey="name"
                valueKey="value"
                data={statusOptions}
                searchable={false}
                value={statusFilter}
                onSelect={(value) => setStatusFilter(value)}
                style={{ width: '100%' }}
                cleanable={false}
            />
        </Col>
        <Col xs={24} md={12} lg={5} lgPush={2}  className='sm-pb-10'>
            <Text className='mb-4 text-small'>Sort by</Text>
            <SelectPicker
                labelKey="name"
                valueKey="value"
                data={sortOptions}
                searchable={false}
                value={sortFilter}
                onSelect={(value) => setSortFilter(value)}
                style={{ width: '100%' }}
                cleanable={false}
            />
        </Col>
    </Row>
);

export default PermitFilters;